export default __webpack_public_path__ + "static/media/Dtac.7f72e9ef.png";